import React, { useState } from "react";
import { Link } from "react-router-dom";

import UserDropdown from "../Dropdowns/UserDropdown.js";

export default function UserSidebar() {
  const [collapseShow, setCollapseShow] = useState("hidden")
  const [shadow, setShadow] = useState(null)
  return (
    <>
      <nav className="z-10">
        <div className="absolute left-0 top-0 flex-row flex-nowrap shadow-xl flex flex-wrap items-center justify-between w-full z-2 py-4 px-6">
          <div className="items-stretch min-h-full flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
            {/* Toggler */}
            <button
              className="cursor-pointer text-black opacity-50 px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
              type="button"
              onClick={() => { setCollapseShow("bg-white py-3 px-6"); setShadow("z-10") }}
            >
              <i className="fas fa-bars"></i>
            </button>
            {/* User */}
            <ul className="items-center flex flex-wrap list-none">
              <li className="inline-block relative">
                <UserDropdown />
              </li>
            </ul>
            {/* Collapse */}
          </div>
        </div>

        <div className={"w-full h-screen fixed top-0 left-0 right-0 bottom-0 bg-darkBlue " + shadow} onClick={() => { setCollapseShow("hidden"); setShadow(null) }}>
          <div
            className={
              "w-64 flex flex-col items-stretch opacity-100 shadow-none shadow fixed top-0 left-0 right-0 bottom-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 " +
              collapseShow
            }
          >
            {/* Collapse header */}
            <div className="min-w-full block pb-4 mb-4 border-b border-solid border-blueGray-200">
              <div className="flex flex-wrap">
                <div className="w-6/12">
                  <Link
                    className="block text-left pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                    to="/"
                  >
                    Uztelecom Infosystems
                  </Link>
                </div>
                <div className="w-6/12 flex justify-end">
                  <button
                    type="button"
                    className="cursor-pointer text-black opacity-50 px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    onClick={() => { setCollapseShow("hidden"); setShadow(null) }}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>

            {/* Navigation */}

            <ul className="flex-col min-w-full flex flex-col list-none mb-4">
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/user/profile") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/user/profile"
                >
                  <i className="fas fa-user-circle text-blueGray-400 mr-2 text-sm"></i>{" "}
                  Profile Page
                </Link>
              </li>
              <li className="items-center">
                <span
                  className="text-blueGray-700 text-xs uppercase py-3 font-bold flex flex-grow"
                >
                  <span className="mr-auto">
                    <i className="fas fa-tasks text-blueGray-400 mr-2 text-sm"></i>{" "}
                    Projects
                  </span>
                  <i className={"fas fa-angle-down text-blueGray-400 mr-2 text-sm"}></i>
                </span>
                <ul className={"flex-col min-w-full flex flex-col list-none ml-4"}>
                  <li className="items-center">
                    <Link
                      to="/user/projects"
                      className={
                        "text-xs uppercase py-3 font-bold block " +
                        (window.location.href.indexOf("/user/projects") !== -1
                          ? "text-lightBlue-500 hover:text-lightBlue-600"
                          : "text-blueGray-700 hover:text-blueGray-500")
                      }>
                      Project 1
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}